import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOutlinedUndoIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("circle", {
			cx: 11,
			cy: 11,
			r: 10.25,
			transform: "matrix(-1 0 0 1 23 1)",
			fill: "white",
			stroke: "#1F3B44",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.19981 12C8.19981 9.34898 10.3488 7.19995 12.9998 7.19995C15.6508 7.19995 17.7998 9.34898 17.7998 12C17.7998 14.6509 15.6508 16.8 12.9998 16.8",
			stroke: "#1F3B44",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.6001 11L8.2001 13.4L5.8001 11",
			stroke: "#1F3B44",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgOutlinedUndoIcon);
const Memo = memo(ForwardRef);
export default Memo;
